// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5ca2838","879":"036e1f43"}[chunkId] + ".chunk.js";
};